import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=2a42bef1&scoped=true&"
import script from "./SocialShare.vue?vue&type=script&lang=ts&"
export * from "./SocialShare.vue?vue&type=script&lang=ts&"
import style0 from "./SocialShare.vue?vue&type=style&index=0&id=2a42bef1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a42bef1",
  null
  
)

export default component.exports